<template>
  <Teleport to="body">
    <div v-show="modelValue" class="wavesurfer" :class="{ active: modelValue }">
      <div class="shadow"></div>
      <div class="content">
        <div class="display" @click="handleDisplay">
          <el-icon color="#737482">
            <ArrowDown />
          </el-icon>
        </div>
        <div class="music_info">
          <a :href="`https://www.biaoshisx.com/ShadowMaterialVideoMusic?id=${id}`" target="_blank"><img
              :src="audioInfo.showImage" :alt="audioInfo.title" class="music_err_pic" /></a>
          <div class="music_info_text">
            <h2>{{ audioInfo.title }}</h2>
            <p>素材ID：{{ audioInfo.code }}</p>
          </div>
        </div>
        <div class="music_cut_song">
          <span title="上一首" @click="handleChange(-1)">
            <svg-icon icon-class="play2"></svg-icon>
          </span>
          <div class="music_btn" @click="playAudio()" :class="{ play: isPlaying }">
            <span class="icon">
              <svg-icon icon-class="play" v-if="!isPlaying"></svg-icon>
            </span>
          </div>
          <span title="下一首" @click="handleChange(1)">
            <svg-icon icon-class="play1"></svg-icon>
          </span>
        </div>
        <div class="music_wavesurfe" @mousemove="handleMouse" :data-url="audioInfo.filePath">
          <div class="hover" :style="`width: ${hoverLeft}px;`"></div>
          <div class="wave" ref="waveRef"></div>
        </div>
        <div class="music_timer">
          <p>
            {{ currentTime }}
          </p>
          <span>/</span>
          <p>{{ totalTime }}</p>
        </div>
        <div
          style="width: 30px;height: 100%;color:#FFF;margin-top: 5px;margin-left: 15px;position: relative;display: flex;align-items: center;justify-content: center;flex-direction: column;row-gap: 8px;padding-bottom: 9px;">
          <!-- <el-tooltip class="item" effect="dark" content="音量" placement="bottom"> -->
          <!-- <el-popover placement="top-start" trigger="click" style="min-width: 38px;margin-left: 10px"> -->
          <div v-if="volumeShow" class="block"
            style="width: 42px;height: 50px;position: absolute;top: -153px;left: -8px;">
            <div
              style="width: 42px;height: 120px;background: #FFF;border-radius: 12px;padding-top: 10px;padding-bottom: 10px;display: flex;align-items: center;justify-content: center;">
              <el-slider v-model="sliderValue" size="small" vertical height="80px" @change="setVolume" />
            </div>
          </div>
          <div @click.stop="volumeShow = !volumeShow">
            <img src="@/assets/lb.png" alt="" srcset="">
          </div>
          <div style="color: #000;">
            <span>音量</span>
          </div>
          <!-- </el-popover> -->
          <!-- </el-tooltip> -->
        </div>
        <div class="music_options">
          <div class="options_item none_select" @click="() => {
            historyShow = !historyShow;
          }
            ">
            <el-icon>
              <Operation />
            </el-icon>
            <p>播放记录</p>
          </div>
          <div class="options_item none_select" @click="download(audioInfo.id)">
            <button>下载</button>
          </div>
        </div>
      </div>
      <div class="song_lists" :class="{ active: historyShow }">
        <div class="tit">
          <p>历史播放记录</p>
          <span>({{ total }})</span>
          <i @click="() => {
            historyShow = false;
          }
            ">
            <el-icon>
              <Close />
            </el-icon>
          </i>
        </div>
        <div class="lists">
          <div class="item" v-for="(item, index) in historyList" :key="index">
            <div class="head">
              <div class="music_btn" :class="{ play: isPlaying && fileId == item.id }" @click="handleListPlay(item)">
                <span class="icon">
                  <svg-icon icon-class="play" v-if="!isPlaying || fileId !== item.id"></svg-icon>
                </span>
              </div>
              <img :data-url="item.showImage" :src="item.showImage" :alt="item.title" class="music_err_pic" />
            </div>
            <div class="text_c">
              <p>{{ item.title }}</p>
              <div class="timer">
                <p>
                  {{ isPlaying && fileId == item.id ? currentTime : "00:00" }}
                </p>
                <span>/</span>
                <p>{{ item.playTime }}</p>
              </div>
            </div>
            <div class="options">
              <el-tooltip class="box-item" effect="dark" content="删除" placement="top-start">
                <span class="icon" @click="handleDelete(item.id)"><el-icon :size="22">
                    <Delete />
                  </el-icon></span>
              </el-tooltip>
              <el-tooltip class="box-item" effect="dark" content="下载" placement="top-start">
                <span class="icon" @click="handlePay(item.id)"><el-icon :size="22">
                    <ShoppingTrolley />
                  </el-icon></span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>
<script>
export default {
  name: "wave-surfer",
  inheritAttrs: false, // 需要加这一行来避免未知 props 的错误
};
</script>
<script setup>
import { ref, watch, onMounted, nextTick } from "vue";
import { useRouter } from "vue-router";
import WaveSurfer from "wavesurfer.js";
import { ElMessageBox } from "element-plus";
const emit = defineEmits(["update:modelValue", "stop", "play", "download_"]);
const router = useRouter();
const sliderValue = ref(100);
const volumeShow = ref(false);
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  id: {
    type: Number,
  },
  code: {
    type: String,
  },
  showImage: {
    type: String,
  },
  title: {
    type: String,
  },
  filePath: {
    type: String,
  },
  playTime: {
    type: String,
  },
});
const isPlaying = ref(true);
const waveRef = ref(null);
const wavesurfer = ref({});
const hoverLeft = ref(0);
const currentTime = ref("00:00");
const totalTime = ref("00:00");
const audioInfo = ref({});
const fileId = ref("");
const historyShow = ref(false);
const total = ref(0);
const historyList = ref([]);
const download = () => {
  emit("download_", audioInfo.value.id);
}
const playAudio = () => {
  isPlaying.value = !isPlaying.value;
  wavesurfer.value.playPause.bind(wavesurfer.value)();
  if (!isPlaying.value) {
    emit("stop", audioInfo.value.id);
  } else {
    emit("play", audioInfo.value.id);
  }
};
const switchAudio = () => {
  wavesurfer.value.load(
    "/oss" +
    audioInfo.value.filePath.replace(
      "http://bssx.oss-cn-beijing.aliyuncs.com",
      ""
    )
  );
  fileId.value = audioInfo.value.id;
  const localStorageMusics = JSON.parse(
    localStorage.getItem("history_musics") || "[]"
  );
  if (!localStorageMusics.some((x) => x.id == audioInfo.value.id)) {
    localStorageMusics.push({ ...audioInfo.value });
    localStorage.setItem("history_musics", JSON.stringify(localStorageMusics));
  }
  total.value = localStorageMusics.length;
  historyList.value = localStorageMusics;
};
const handleMouse = (e) => {
  hoverLeft.value = e.offsetX;
};
const secondsToMMSS = (seconds) => {
  // 将秒数转换为分钟和秒数
  let minutes = Math.floor(seconds / 60); // 计算分钟
  seconds = seconds % 60; // 计算剩余秒数

  // 将分钟和秒数转换为字符串，位数不足前面补零
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;

  // 返回格式化的时间字符串
  return minutes + ":" + seconds;
};
const setVolume = (val) => {
  // console.log(val)
  wavesurfer.value.setVolume(sliderValue.value == 0 ? 0 : sliderValue.value / 100);
  setTimeout(() => {
    volumeShow.value = false;
  }, 2000)
}
const handleDisplay = () => {
  handleStop();
  emit("update:modelValue", false);
};
const handlePay = (id) => {
  router
    .push({
      path: "/ShadowMaterialVideoMusic",
      query: {
        id: id,
      },
    })
    .then(() => {
      location.reload();
    });
};
const handleDelete = (id) => {
  ElMessageBox.confirm("确定从历史播放记录中删除当前素材吗?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      let deleteAudio = historyList.value.find((x) => x.id == id);
      let deleteIndex = historyList.value.findIndex((x) => x.id == id);
      historyList.value.splice(deleteIndex, 1);
      total.value = historyList.value.length;
      localStorage.setItem("history_musics", JSON.stringify(historyList.value));
    })
    .catch(() => { });
};
const handleChange = (page) => {
  handleStop();
  let index = historyList.value.findIndex((x) => x.id == audioInfo.value.id);
  if (page < 0) {
    index--;
    if (index < 0) {
      index = historyList.value.length - 1;
    }
  } else if (page > 0) {
    index++;
    if (index > historyList.value.length - 1) {
      index = 0;
    }
  }
  audioInfo.value = historyList.value[index];
  fileId.value = audioInfo.value.id;
  wavesurfer.value.load(
    "/oss" +
    audioInfo.value.filePath.replace(
      "http://bssx.oss-cn-beijing.aliyuncs.com",
      ""
    )
  );
};
const handleListPlay = (audio) => {
  if (isPlaying.value && audio.id === audioInfo.value.id) {
    handleStop();
    return;
  }
  handleStop();
  audioInfo.value = audio;
  fileId.value = audioInfo.value.id;
  wavesurfer.value.load(
    "/oss" +
    audioInfo.value.filePath.replace(
      "http://bssx.oss-cn-beijing.aliyuncs.com",
      ""
    )
  );
};
const handleStop = () => {
  isPlaying.value = false;
  wavesurfer.value.stop.bind(wavesurfer.value)();
  emit("stop", audioInfo.value.id);
};
onMounted(() => {
  nextTick(() => {
    wavesurfer.value = WaveSurfer.create({
      // 波形图的容器
      container: waveRef.value,
      // 已播放波形的颜色
      progressColor: "#16172f",
      // 未播放波形的颜色
      // waveColor: "lightgrey",
      // 波形图的高度，单位为px
      height: 40,
      // 是否显示滚动条，默认为false
      // scrollParent: false,
      // 波形的振幅（高度），默认为1
      barHeight: 1,
      // 波形条的圆角
      barRadius: 2,
      // 波形条的宽度
      barWidth: 1.5,
      // 波形条间的间距
      barGap: 3,
      // 播放进度光标条的颜色
      cursorColor: "#16172f",
      // 播放进度光标条的宽度，默认为1
      cursorWidth: 1.5,
      volume: .1,
      // 音频的播放速度
      // audioRate: "1",
      // （与区域插件一起使用）启用所选区域的循环
      // loopSelection:false
    });
    wavesurfer.value.on("audioprocess", () => {
      if (wavesurfer.value.isPlaying()) {
        const _currentTime = parseInt(wavesurfer.value.getCurrentTime());
        const _totalTime = parseInt(wavesurfer.value.getDuration());
        if (_currentTime == _totalTime && !!_totalTime) {
          isPlaying.value = false;
          emit("stop", audioInfo.value.id);
        }
        currentTime.value = secondsToMMSS(_currentTime);
        totalTime.value = secondsToMMSS(_totalTime);
      }
    });
    wavesurfer.value.on("ready", function () {
      playAudio();
    });
  });
});

watch(
  () => props.id,
  (newId, oldId) => {
    if (!!oldId) {
      emit("stop", oldId);
    }
    wavesurfer.value.stop.bind(wavesurfer.value)();
    isPlaying.value = false;
    audioInfo.value = {
      id: props.id,
      code: props.code,
      showImage: props.showImage,
      title: props.title,
      filePath: props.filePath,
      playTime: props.playTime,
    };
    switchAudio();
  }
);
defineExpose({
  isPlaying,
  handleDisplay,
  handleStop,
  playAudio,
});
</script>
<style lang="less" scoped>
.wavesurfer {
  position: fixed;
  width: 100%;
  height: 80px;
  background-color: #fff;
  bottom: 0;
  left: 0;
  fill: #fff;
  z-index: 1000;
  transition: 0.2s ease-in-out;
  -webkit-transition: 0.2s ease-in-out;
  -moz-transition: 0.2s ease-in-out;
  -ms-transition: 0.2s ease-in-out;
  -o-transition: 0.2s ease-in-out;
  transform: translateY(20px);
  -webkit-transform: translateY(20px);
  -moz-transform: translateY(20px);
  -ms-transform: translateY(20px);
  -o-transform: translateY(20px);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;

  &.active {
    pointer-events: initial;
    opacity: 1;
    visibility: visible;
    transform: translateY(0px);
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
  }

  .shadow {
    width: 100%;
    height: 20px;
    border-radius: 4px;
    background: linear-gradient(0deg,
        rgba(22, 23, 47, 0.06) 0%,
        rgba(22, 23, 47, 0));
    position: absolute;
    bottom: 80px;
    left: 0;
    z-index: 299;
  }

  .content {
    margin: 0 auto;
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: center;
    width: 100%;

    .display {
      width: 20px;
      height: 56px;
      border-radius: 2px;
      background: #f6f7fc;
      text-align: center;
      line-height: 26px;
      cursor: pointer;
      margin-right: 8px;
      line-height: 56px;
      z-index: 400;
      transition: 0.2s all;

      &:hover {
        background-color: #dfe0e6;
      }
    }

    .music_info {
      display: flex;
      align-items: center;
      margin-right: 32px;

      &>a {
        display: flex;
        width: 56px;
        height: 56px;
        border-radius: 4px;
        margin-right: 12px;
        overflow: hidden;

        &>img {
          width: 100%;
          height: 100%;
          -o-object-fit: cover;
          object-fit: cover;
        }
      }

      .music_info_text {
        display: flex;
        flex-direction: column;

        * {
          font-size: 14px;
          line-height: 22px;
        }

        h2 {
          color: #16172f;
          font-weight: 700;
          width: 256px;
          margin-bottom: 8px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }

    .music_cut_song {
      display: flex;
      align-items: center;

      &>span {
        color: #16172f;
        font-size: 24px;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }

      .music_btn {
        width: 48px;
        height: 48px;
        margin: 0 12px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10;
        cursor: pointer;
        background-color: #16172f;

        &.play {
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #16172f;

          .icon {
            display: inline-block;
            width: 2px;
            height: 16px;
            border-radius: 100px;
            transform-origin: 50% 100%;
            background-color: #fff;
            transition: all 0.2s ease-out;
            animation: widget-music 1.5s linear infinite running;
            margin-bottom: 3px;
            transform: scaleY(0.6);
            animation-delay: -0.5s;

            &::after {
              content: "";
              position: absolute;
              right: 6px;
              bottom: 0;
              display: inline-block;
              width: 2px;
              height: 16px;
              background-color: #fff;
              border-radius: 100px;
              transform-origin: 50% 100%;
              transition: all 0.2s ease-out;
              animation: widget-music 1.5s linear infinite running;
              transform: scaleY(0.8);
              animation-delay: -0.3s;
            }

            &::before {
              content: "";
              position: absolute;
              left: 6px;
              bottom: 0;
              display: inline-block;
              width: 2px;
              height: 16px;
              background-color: #fff;
              transform-origin: 50% 100%;
              border-radius: 100px;
              transition: all 0.2s ease-out;
              animation: widget-music 1.5s linear infinite running;
              transform: scaleY(0.9);
            }
          }
        }

        &>span {
          color: #fff;
          font-size: 24px;
          width: 24px;
          height: 24px;
        }
      }
    }

    .music_wavesurfe {
      height: 40px;
      margin: 0 16px 0 24px;
      flex: 1;
      position: relative;

      .hover {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 10;
        pointer-events: none;
        height: 100%;
        width: 0;
        mix-blend-mode: overlay;
        background: #16172f;
        opacity: 0;
        transition: opacity 0.2s ease;
      }

      &:hover {
        .hover {
          opacity: 1 !important;
        }
      }

      .wave {
        display: block;
        user-select: none;
        height: 40px;
        overflow: hidden;
      }
    }

    .music_timer {
      display: flex;
      align-items: center;

      &>* {
        color: #737482;
        font-size: 14px;
        line-height: 22px;
      }

      &>span {
        margin: 0 4px;
      }
    }

    .music_options {
      display: flex;
      align-items: center;
      margin-left: 10px;

      .options_item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 32px;
        cursor: pointer;
        user-select: none;

        &:last-child {
          margin-right: 0;
        }

        &>i {
          width: 24px;
          height: 24px;
          display: flex;
          line-height: 24px;
          text-align: center;
          color: #16172f;
          font-size: 24px;
        }

        p {
          margin-top: 4px;
          color: #16172f;
          font-size: 12px;
          line-height: 20px;
        }

        button {
          display: inline-block;
          position: relative;
          outline: none;
          border: none;
          cursor: pointer;
          white-space: nowrap;
          transition: all 0.2s;
          box-sizing: border-box;
          color: #fff;
          -webkit-user-select: none;
          -moz-user-select: none;
          user-select: none;
          padding: 0 28px;
          height: 40px;
          border-radius: 100px;
          background: #16172f;
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
  }

  .song_lists {
    width: 440px;
    border-radius: 4px 0 0 0;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 0;
    bottom: 80px;
    z-index: 299;
    box-shadow: -4px -4px 8px rgba(0, 0, 0, 0.04);
    pointer-events: none;
    opacity: 0;
    visibility: hidden;
    transform: translateY(10px);
    transition: 0.2s;

    &.active {
      transform: translateY(0px);
      pointer-events: initial;
      opacity: 1;
      visibility: visible;
    }

    .tit {
      border-bottom: 1px solid #ebecf0;
      padding: 24px 0 16px 24px;
      display: flex;
      align-items: baseline;

      p {
        color: #16172f;
        font-size: 18px;
        line-height: 26px;
      }

      span {
        font-size: 14px;
        line-height: 22px;
      }

      i {
        margin-left: auto;
        color: #737482;
        cursor: pointer;
        margin-right: 24px;
      }
    }

    .lists {
      display: flex;
      flex-direction: column;
      height: 500px;
      overflow-y: auto;
      margin: 8px 0;

      .item {
        width: 100%;
        padding: 12px 24px;
        display: flex;
        align-items: center;

        * {
          position: relative;
        }

        .head {
          width: 48px;
          height: 48px;
          margin-right: 16px;
          border-radius: 4px;
          overflow: hidden;

          &::after {
            content: "";
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.24);
            position: absolute;
            left: 0;
            top: 0;
          }

          .music_btn {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 24px;
            height: 24px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 10;
            cursor: pointer;

            .icon {
              color: #fff;
              font-size: 24px;
            }

            &.play {
              display: flex;
              align-items: center;
              justify-content: center;

              .icon {
                display: inline-block;
                width: 2px;
                height: 16px;
                border-radius: 100px;
                transform-origin: 50% 100%;
                background-color: #fff;
                transition: all 0.2s ease-out;
                animation: widget-music 1.5s linear infinite running;
                margin-bottom: 3px;
                transform: scaleY(0.6);
                animation-delay: -0.5s;

                &::before {
                  content: "";
                  position: absolute;
                  left: 6px;
                  bottom: 0;
                  display: inline-block;
                  width: 2px;
                  height: 16px;
                  background-color: #fff;
                  transform-origin: 50% 100%;
                  border-radius: 100px;
                  transition: all 0.2s ease-out;
                  animation: widget-music 1.5s linear infinite running;
                  transform: scaleY(0.9);
                }

                &::after {
                  content: "";
                  position: absolute;
                  right: 6px;
                  bottom: 0;
                  display: inline-block;
                  width: 2px;
                  height: 16px;
                  background-color: #fff;
                  border-radius: 100px;
                  transform-origin: 50% 100%;
                  transition: all 0.2s ease-out;
                  animation: widget-music 1.5s linear infinite running;
                  transform: scaleY(0.9);
                }
              }
            }
          }

          &>img {
            width: 100%;
            height: 100%;
            -o-object-fit: cover;
            object-fit: cover;
          }
        }

        .text_c {
          display: flex;
          flex-direction: column;
          width: calc(100% - 144px);

          &>p {
            color: #16172f;
            margin-bottom: 4px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
            line-height: 22px;
          }

          .timer {
            display: flex;
            align-items: center;

            &>p {
              color: #737482;
              font-size: 14px;
              line-height: 22px;
            }

            &>span {
              color: #737482;
              margin: 0 4px;
              font-size: 14px;
              line-height: 22px;
            }
          }
        }

        .options {
          display: flex;

          .icon {
            width: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 16px;
            cursor: pointer;
          }
        }
      }
    }
  }
}

@keyframes widget-music {

  0%,
  100% {
    transform: scale(1);
  }

  20% {
    transform: scaleY(0.5);
  }

  40% {
    transform: scaleY(0.7);
  }

  60% {
    transform: scaleY(0.3);
  }

  80% {
    transform: scaleY(0.6);
  }
}
</style>
